<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="search-outline"></nb-icon>
        <div class="ml-2" i18n>Viewing Survey: {{ survey.survey_id }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <strong class="text-uppercase" i18n>Survey Details</strong>

    <div class="row">
      <div class="col-4"><div i18n>Survey ID:</div></div>
      <div class="col-8">
        <div>{{ survey.survey_id }}</div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-4"><div i18n>Survey Name:</div></div>
      <div class="col-8">
        <div>{{ survey.survey_name }}</div>
      </div>
    </div>
    <br />

    <div *ngFor="let questions of survey.questions">
      <div class="row">
        <nb-accordion style="width: 100%">
          <nb-accordion-item style="width: 100%">
            <nb-accordion-item-header>
              <div class="col-auto mr-auto">
                <div i18n>Question: {{ questions.question_id }}</div>
              </div>
            </nb-accordion-item-header>
            <nb-accordion-item-body>
              <div class="row">
                <div class="col-4"><div i18n>Question ID:</div></div>
                <div class="col-8">
                  <div>{{ questions.question_id }}</div>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-4"><div i18n>Question Type:</div></div>
                <div class="col-8">
                  <div>{{ questions.question_type }}</div>
                </div>
              </div>
              <br />

              <div class="row">
                <div class="col-4"><div i18n>Question Name:</div></div>
                <div class="col-8">
                  <div>{{ questions.question_name }}</div>
                </div>
              </div>
              <br />

              <div class="row">
                <div class="col-4"><div i18n>Visible</div></div>
                <div class="col-8">
                  <nb-checkbox disabled name="visible" [(ngModel)]="questions.visible"></nb-checkbox>
                </div>
              </div>
              <br />

              <div class="row">
                <div class="col-4"><div i18n>Question Value:</div></div>
                <div class="col-8">
                  <div>{{ questions.value }}</div>
                </div>
              </div>
              <br />

              <div class="row">
                <div class="col-4"><div i18n>Question Image ID:</div></div>
                <div class="col-8">
                  <div>{{ questions.image_id }}</div>
                </div>
              </div>
              <br />

              <div class="row">
                <div class="col-4"><div i18n>Question Title ID:</div></div>
                <div class="col-8">
                  <div>{{ questions.title_id }}</div>
                </div>
              </div>
              <br />

              <div class="row">
                <div class="col-4"><div i18n>Question Subtitle ID:</div></div>
                <div class="col-8">
                  <div>{{ questions.subtitle_id }}</div>
                </div>
              </div>
              <br />

              <div class="row">
                <div class="col-4"><div i18n>Question Display Order:</div></div>
                <div class="col-8">
                  <div>{{ questions.display_order }}</div>
                </div>
              </div>
              <br />

              <div *ngFor="let answers of questions.answers">
                <nb-accordion>
                  <nb-accordion-item>
                    <nb-accordion-item-header i18n>Answer: {{ answers.answer_id }}</nb-accordion-item-header>
                    <nb-accordion-item-body>
                      <div class="row">
                        <div class="col-4"><div i18n>Answer ID:</div></div>
                        <div class="col-8">
                          <div>{{ answers.answer_id }}</div>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col-4"><div i18n>Answer Type:</div></div>
                        <div class="col-8">
                          <div>{{ answers.answer_type }}</div>
                        </div>
                      </div>
                      <br />

                      <div class="row">
                        <div class="col-4"><div i18n>Value:</div></div>
                        <div class="col-8">
                          <div>{{ answers.value }}</div>
                        </div>
                      </div>
                      <br />

                      <div class="row">
                        <div class="col-4"><div i18n>Value ID:</div></div>
                        <div class="col-8">
                          <div>{{ answers.value_id }}</div>
                        </div>
                      </div>
                      <br />

                      <div class="row">
                        <div class="col-4"><div i18n>Minimum Value:</div></div>
                        <div class="col-8">
                          <div>{{ answers.min_value }}</div>
                        </div>
                      </div>
                      <br />

                      <div class="row">
                        <div class="col-4">
                          <div i18n>Minimum Value Description:</div>
                        </div>
                        <div class="col-8">
                          <div>{{ answers.min_value_text }}</div>
                        </div>
                      </div>
                      <br />

                      <div class="row">
                        <div class="col-4">
                          <div i18n>Minimum Value Description ID:</div>
                        </div>
                        <div class="col-8">
                          <div>{{ answers.min_value_text_id }}</div>
                        </div>
                      </div>
                      <br />

                      <div class="row">
                        <div class="col-4"><div i18n>Maximum Value:</div></div>
                        <div class="col-8">
                          <div>{{ answers.max_value }}</div>
                        </div>
                      </div>
                      <br />

                      <div class="row">
                        <div class="col-4">
                          <div i18n>Maximum Value Description:</div>
                        </div>
                        <div class="col-8">
                          <div>{{ answers.max_value_text }}</div>
                        </div>
                      </div>
                      <br />

                      <div class="row">
                        <div class="col-4">
                          <div i18n>Maximum Value Description ID:</div>
                        </div>
                        <div class="col-8">
                          <div>{{ answers.max_value_text_id }}</div>
                        </div>
                      </div>
                      <br />

                      <div class="row">
                        <div class="col-4">
                          <div i18n>Answer Image ID:</div>
                        </div>
                        <div class="col-8">
                          <div>{{ answers.image_id }}</div>
                        </div>
                      </div>
                      <br />

                      <div *ngFor="let actions of answers.actions">
                        <nb-accordion>
                          <nb-accordion-item>
                            <nb-accordion-item-header i18n>Action:</nb-accordion-item-header>
                            <nb-accordion-item-body>
                              <div class="row">
                                <div class="col-4">
                                  <div i18n>Action Type:</div>
                                </div>
                                <div class="col-8">
                                  <div>{{ actions.action_type }}</div>
                                </div>
                              </div>
                              <br />

                              <div class="row">
                                <div class="col-4">
                                  <div i18n>Action Value:</div>
                                </div>
                                <div class="col-8">
                                  <div>{{ actions.action_value }}</div>
                                </div>
                              </div>
                              <br />

                              <div class="row">
                                <div class="col-4"><div i18n>Deleted</div></div>
                                <div class="col-8">
                                  <nb-checkbox disabled name="visible" [(ngModel)]="actions.deleted"></nb-checkbox>
                                </div>
                              </div>
                              <br />

                              <div *ngIf="actions.action_payload">
                                <strong class="text-uppercase" i18n>Action Payload</strong>
                                <div class="row">
                                  <div class="col-4">
                                    <div i18n>Deleted</div>
                                  </div>
                                  <div class="col-8">
                                    <nb-checkbox
                                      disabled
                                      name="visible"
                                      [(ngModel)]="actions.action_payload.deleted"
                                    ></nb-checkbox>
                                  </div>
                                </div>
                                <br />

                                <div class="row">
                                  <div class="col-4"><div i18n>URL:</div></div>
                                  <div class="col-8">
                                    <div>{{ actions.action_payload.url }}</div>
                                  </div>
                                </div>
                                <br />
                              </div>
                            </nb-accordion-item-body>
                          </nb-accordion-item>
                        </nb-accordion>
                      </div>
                    </nb-accordion-item-body>
                  </nb-accordion-item>
                </nb-accordion>
              </div>
            </nb-accordion-item-body>
          </nb-accordion-item>
        </nb-accordion>
      </div>
    </div>
  </nb-card-body>
</nb-card>
